import React from "react";
import classes from "./Certificate.module.css";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import modalClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import { certificate } from "../../../../../constant/imagePath";

const Certificate = ({ show, setShow, data }) => {
  return (
    <>
      <style>{`
      .modal-body{
        padding:0px;
      }
              @media screen and (max-width: 580px) {
            .modal .modal-dialog {
              width: 95% !important;
              margin: 0px 10%;
            }
        }
            @media screen and (max-width: 768px) {
                .${modalClasses.header} {
                    margin:24px;
                  }
            }

      `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        width={"600px"}
        headerStyles={{
          marginBottom: "0px",
          paddingBottom: "0px",
          display: "flex",
          justifyContent: "center",
        }}
        borderRadius={"20px"}
        header={<div />}
      >
        <div className={[classes.MiddleContent]}>
          <h4
            style={{ color: Colors.neutralShadesOfNero, ...Fonts.h4 }}
            className={[classes.mb12]}
          >
            {data?.certificateName}
          </h4>
          <p style={{ color: Colors.neutralShadesOfDimGray, ...Fonts.p1 }}>
            Expiration date:{" "}
            <span style={{ color: Colors.neutralShadesOfNero, ...Fonts.p1 }}>
              {data?.date}
            </span>
          </p>
          <div
            className={[classes.certificateImgDiv]}
            style={{ border: `1px solid ${Colors.neutralShadesOfWhisper}` }}
          >
            <img src={data?.img} alt="..." />
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
};

Certificate.defaultProps = {
  data: {
    img: certificate,
    date: "Jan 16, 2021",
    certificateName: "Certificate Name",
  },
};

export default Certificate;
